module.exports = __webpack_public_path__ + "static/media/icon-deal-registration.60920d12.svg";